import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Button, Col, Form } from "react-bootstrap";
import RightArrow from "../../assets/images/right-arrow-white.svg";
import Radio from "../common/Radio";

class SelectVerificationMethod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verify: true,
    };
  }

  onOptionsChange = (value) => {
    this.setState({
      verify: value,
    });
  };

  onNextClick = (e) => {
    const { onNext } = this.props;
    const { verify } = this.state;
    onNext(e, { verify });
  };

  render() {
    const {
      t,
      title,
      desc,
      radioSelections: { label, options },
      onBack,
    } = this.props;
    const { verify } = this.state;
    return (
      <>
        <div className="wrapper__container-card-body">
          <h1 className="wrapper__container-card-body-title">{t(title)}</h1>
          <p className="wrapper__container-card-body-desc">{t(desc)}</p>
          <Form className="wrapper__container-card-body-verification-method">
            <Form.Row>
              <Col className="pr-2" lg={{ span: 12 }}>
                <Form.Group controlId="verify">
                  <Form.Label className="form-radio-label">
                    {t(label)}
                  </Form.Label>
                  {options.map((option, index) => {
                    const { displayValue, value } = option;
                    return (
                      <Radio
                        key={displayValue}
                        name={`verify${index}`}
                        label={displayValue}
                        value={value}
                        isChecked={verify === value}
                        handleChange={this.onOptionsChange}
                      />
                    );
                  })}
                </Form.Group>
              </Col>
            </Form.Row>
          </Form>
        </div>
        <div className="separator" />
        <div className="wrapper__container-card-footer">
          <Button
            className="wrapper__container-card-body-submit"
            size="lg"
            variant="primary"
            block
            type="submit"
            onClick={(e) => this.onNextClick(e)}
          >
            {t("pages.identity.next")}
            <img src={RightArrow} alt="" />
          </Button>
          <div className="wrapper__container-card-footer-link">
            <Button variant="link" className="wrapper__container-card-footer-link-btn" onClick={onBack}>{t("pages.identity.goBack")}</Button>
          </div>
        </div>
      </>
    );
  }
}

SelectVerificationMethod.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  desc: PropTypes.string,
  radioSelections: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

SelectVerificationMethod.defaultProps = {
  desc: "",
};

export default withTranslation()(SelectVerificationMethod);
